import { render } from "./WhatsAppView.vue?vue&type=template&id=d413edd8&scoped=true"
import script from "./WhatsAppView.vue?vue&type=script&lang=js"
export * from "./WhatsAppView.vue?vue&type=script&lang=js"

import "./WhatsAppView.vue?vue&type=style&index=0&id=d413edd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d413edd8"]])

export default __exports__